import { useEffect } from "react";
import { Form, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { capitalizeWords } from "../../helpers/helpers";
import {
  getAllStates,
  updateErrorStatus,
  editEntDets,
  entDetailedView,
} from "../../redux/slices/enterpriseSlice";
import {
  editBusDets,
  getBusDetailedView,
  clearBusError,
} from "../../redux/slices/BusSlice";
import {
  clearInvErr,
  editinvestorDets,
  investorDetailedView,
} from "../../redux/slices/investorSlice";
import CustomInput from "../CustomInput/Input";
import CustomSelect from "../CustomSelect/CustomSelect";
import { ERROR_MSGS, BTN_TXT } from "../../constants/constants";
import {
  address1Rules,
  address2Rules,
  cityRules,
  pincodeRules,
} from "../../helpers/helpers";
import FormFooter from "./FormFooter";

const ComAddressForm = ({ data, onClose, isEnt, isBus, isInv }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const {
    editEntSaveLoading,
    editError: editEntErr,
    statesData,
  } = useSelector((state) => state?.enterprise);
  const { editSaveloading, editError: editBusErr } = useSelector(
    (state) => state?.business,
  );
  const { editInvSaveLoading, editError: editInvErr } = useSelector(
    (state) => state?.investor,
  );

  useEffect(() => {
    dispatch(getAllStates());
    return () => {
      dispatch(updateErrorStatus());
      dispatch(clearBusError());
      dispatch(clearInvErr());
    };
  }, [dispatch]);

  const handleOnFinish = async (values) => {
    const payload = {
      address: {
        addressLine1: values?.addressLine1,
        addressLine2: values?.addressLine2,
        city: values?.city,
        pinCode: values?.pincode,
        state: values?.state,
      },
    };

    let action;
    if (isEnt) {
      payload.entId = data?.entId;
      action = editEntDets;
    } else if (isBus) {
      payload.orgId = data?.orgId;
      payload.modifiedAt = data?.modifiedAt;
      action = editBusDets;
    } else if (isInv) {
      payload.orgId = data?.orgId;
      action = editinvestorDets;
    }

    const res = await dispatch(action(payload));
    if (res.payload.statusCode === 201) {
      if (isEnt) {
        dispatch(entDetailedView(data?.entId));
      } else if (isBus) {
        dispatch(
          getBusDetailedView({
            orgId: data?.orgId,
            dealCategoryId: data?.dealCategoryId,
          }),
        );
      } else if (isInv) {
        dispatch(investorDetailedView(data?.orgId));
      }
      onClose();
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleOnFinish}
      initialValues={{
        addressLine1: data?.billingAddLine1 || "",
        addressLine2: data?.billingAddLine2 || "",
        city: data?.billingCityName || "",
        state: data?.billingStateName || "",
        pincode: data?.billingZipCode || "",
      }}
    >
      <Row gutter={[24, 0]}>
        <Col xs={24} md={12}>
          <CustomInput
            label="Address Line 1"
            name="addressLine1"
            type="text"
            isRequired={true}
            placeholder="Enter Address Line 1"
            rules={address1Rules}
          />
        </Col>
        <Col xs={24} md={12}>
          <CustomInput
            label="Address Line 2"
            name="addressLine2"
            type="text"
            isRequired={true}
            placeholder="Enter Address Line 2"
            rules={address2Rules}
          />
        </Col>
        <Col xs={24} md={12}>
          <CustomInput
            label="City"
            name="city"
            type="text"
            isRequired={true}
            placeholder="Enter City"
            allowLettersOnly
            rules={cityRules}
          />
        </Col>
        <Col xs={24} md={12}>
          <CustomSelect
            label="State"
            name="state"
            showSearch
            isRequired={true}
            placeholder="Select State"
            options={statesData?.map((state) => ({
              value: state.stateName,
              label: capitalizeWords(state.stateName),
            }))}
            rules={[{ required: true, message: ERROR_MSGS.SEL_STATE }]}
          />
        </Col>
        <Col xs={24} md={12}>
          <CustomInput
            label="Pin Code"
            name="pincode"
            type="text"
            isRequired={true}
            placeholder="Enter Pincode"
            allowNumbersOnly
            maxLength={6}
            rules={pincodeRules}
          />
        </Col>
      </Row>

      <FormFooter
        onCancelClick={() => {
          onClose();
          form.resetFields();
        }}
        submitLoading={
          editEntSaveLoading || editSaveloading || editInvSaveLoading
        }
        btnName={BTN_TXT.SUBMIT}
        error={editEntErr || editBusErr || editInvErr}
      />
    </Form>
  );
};

export default ComAddressForm;
